export function ComingLaterPage({ moduleName }: { moduleName: string }) {
  return (
    <section className="card card--wide">
      <h2>{moduleName}</h2>
      <p>
        This module is not available in the current EPN staging release. It cannot process payroll,
        transmit payments or file payroll-tax returns.
      </p>
    </section>
  );
}
